import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { formatPrice } from '../utils/format';
import { productOrderUrl } from '../utils/whatsapp';
import type { Product } from '../types/catalog';
interface ProductCardProps {
  product: Product;
  onOpen: (product: Product) => void;
}
export function ProductCard({
  product,
  onOpen
}: ProductCardProps) {
  return <article className="flex flex-col" data-id="element-47" data-mp="kcll65b1ubbb">
      <button type="button" onClick={() => onOpen(product)} className="group relative block overflow-hidden rounded-2xl bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-cobalt" aria-label={`Ver ficha de ${product.name}`} data-id="element-48" data-mp="kbjxn1cujwcp">
        <img src={product.image} alt={`Frasco de ${product.name}`} className="aspect-[4/5] w-full object-contain transition-transform duration-300 ease-smooth group-hover:scale-[1.04]" loading="lazy" data-id="element-49" data-mp="ycwav50mhjuw" />
        <span className="absolute left-3 top-3 rounded-full bg-navy px-3 py-1 text-[10px] font-semibold uppercase tracking-wide text-ivory" data-id="element-50" data-mp="303znu0xzjaim">
          {product.family}
        </span>
      </button>

      <h3 className="mt-4 font-display text-lg font-bold leading-tight text-navy" data-id="element-51" data-mp="3gyue129yybh6">
        <button type="button" onClick={() => onOpen(product)} className="text-left transition-colors duration-200 ease-smooth hover:text-cobalt" data-id="element-52" data-mp="3cz20sc9mrh5h">
          {product.name}
        </button>
      </h3>

      <p className="mt-1.5 text-[10px] font-bold uppercase tracking-wide text-cobalt" data-id="element-53" data-mp="8hzhe4jrlnbj">
        Precio de lanzamiento
      </p>
      <p className="mt-1 flex items-baseline gap-2" data-id="element-54" data-mp="3voic7umusu0o">
        <span className="font-display text-lg font-extrabold text-navy" data-id="element-55" data-mp="3vr4mi214pnml">
          {formatPrice(product.price)}
        </span>
        {product.compareAtPrice && <span className="text-sm text-mute line-through" data-id="element-56" data-mp="2kawhzv25028a">
            {formatPrice(product.compareAtPrice)}
          </span>}
      </p>

      <a href={productOrderUrl(product.name)} target="_blank" rel="noreferrer" className="mt-3 flex items-center justify-center gap-2 rounded-full bg-lime px-4 py-3 text-[11px] font-bold uppercase tracking-wide text-navy transition-colors duration-200 ease-smooth hover:bg-lime-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-cobalt" data-id="element-57" data-mp="2fd4nque0s40x">
        <MessageCircleIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-58" data-mp="2csgd0w54agy7" />
        Pedir por WhatsApp
      </a>
    </article>;
}